import { Locale } from './locale';

export default function localizedLowercase(locale: string, value: string) {
    const language = Locale.getLanguage(locale);
    if (language === 'de' || language === 'ja') {
        return value;
    }
    return value.toLowerCase();
}
